import React from 'react';
import { useNavigate } from "react-router-dom";
import PageHeader from "../common/ui/pageheader";

export default function Inbondheading() {
  const navigate = useNavigate();
  const isLoadingAutoFileNumber = false; // or from props/state

  const handleAddInbondClick = () => {
    // do your navigation or logic here
    navigate("/in-bond/add-in-bond");
  };

  return (
    <PageHeader
      title="In-bond"
      subtitle="Here you can record arriving materials."
      buttonText="Add In-bond" // added text
      onButtonClick={handleAddInbondClick}
      disabled={isLoadingAutoFileNumber}
    />
  );
}
